export default __webpack_public_path__ + "static/media/a5.6eebad7a.png";